/* hvs-optimisation 2026-11-03: quick shop on product cards, the badge guide, and Shop or Learn on a collection page. No
   dependencies. The card (snippets/hvs-quick-shop.liquid): the size, minus and plus for the quantity, Add. Every add answers at once (the button
   says Added, the header's cart count moves, a small packet flies to the cart, the count on the button goes up) and the
   request goes behind it through /cart/add.js; taps within 150 ms go together. If the store refuses, the count is put back
   and the button says so. When nothing is left to send, the theme's cart:refresh event and /cart.js set the true counts.
   The sizes already in the cart are read once on load, and only when the header says the cart is not empty.
   The badge guide (snippets/hvs-badge-key.liquid): the link above the grid, or a tap on a badge beside the rating.
   Shop or Learn (snippets/hvs-learn.liquid): Learn opens the panel in the page; the zone chips share the Learning Hub's
   localStorage "hvs-zone". Analytics: the site's gtag, when present. */
(function () {
  'use strict';
  if (window.HVSQuickShop) { return; }
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  function coarse() { return !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches); }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function track(name, params) {
    try {
      if (typeof window.gtag === 'function') { window.gtag('event', name, params || {}); }
      else { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, params || {})); }
    } catch (e) {}
  }
  var live = null;
  function announce(text) {
    if (!live) { live = document.createElement('div'); live.className = 'hvs-qs-live'; live.setAttribute('aria-live', 'polite'); document.body.appendChild(live); }
    live.textContent = ''; setTimeout(function () { live.textContent = text; }, 50);
  }

  /* ---- state: the count in the cart for each size, and what is still to send ---- */
  var qty = {}, pending = {}, gen = 0, busy = false, timer = null, selfRefresh = false, cartRead = false;
  function hasPending() { return Object.keys(pending).length > 0; }

  /* ---- one card ---- */
  function chosen(form) {
    var sel = $('[data-hvs-select]', form);
    if (sel) { return sel.options[sel.selectedIndex] || null; }
    return $('[data-hvs-one]', form);
  }
  function whatOf(form, el) {
    var title = form.getAttribute('data-hvs-qs-title') || '', size = el ? el.getAttribute('data-size') : '';
    return title + (size ? ', ' + size : '');
  }
  function paint(form) {
    var el = chosen(form); if (!el) { return; }
    var q = qty[el.value] || 0, sel = $('[data-hvs-select]', form);
    if (sel) {
      var fs = $('[data-hvs-face-size]', form), fp = $('[data-hvs-face-price]', form);
      if (fs) { fs.textContent = el.getAttribute('data-size') || ''; }
      if (fp) { fp.textContent = el.getAttribute('data-price') || ''; }
      Array.prototype.forEach.call(sel.options, function (o) {
        if (o.disabled) { return; }
        var n = qty[o.value] || 0, text = o.getAttribute('data-size') + ', ' + o.getAttribute('data-price') + (n ? ' (' + n + ' in cart)' : '');
        if (o.textContent !== text) { o.textContent = text; }
      });
    }
    syncQty(form);
    var count = $('[data-hvs-count]', form);
    if (count) { count.hidden = !q; count.textContent = q ? String(q) : ''; count.setAttribute('aria-label', q ? q + ' in your cart' : ''); }
  }
  /* Minus stops at 1 and plus at 999. On touch the count is not typed into, so no keyboard opens over the list. */
  function syncQty(form) {
    var input = $('[data-hvs-qty]', form); if (!input) { return; }
    var n = parseInt(input.value, 10) || 1, minus = $('[data-hvs-qminus]', form), plus = $('[data-hvs-qplus]', form);
    input.readOnly = coarse();
    if (minus) { minus.disabled = n <= 1; }
    if (plus) { plus.disabled = n >= 999; }
  }
  function stepQty(form, delta) {
    var input = $('[data-hvs-qty]', form); if (!input) { return; }
    var n = Math.max(1, Math.min(999, (parseInt(input.value, 10) || 1) + delta));
    input.value = String(n);
    syncQty(form);
    announce('Quantity ' + n + '.');
  }
  function paintAll() { $$('[data-hvs-qs]').forEach(paint); }
  function paintId(id) { $$('[data-hvs-qs]').forEach(function (f) { if ($('option[value="' + id + '"]', f) || $('[data-hvs-one][value="' + id + '"]', f)) { paint(f); } }); }
  function say(form, text, ms) {
    var btn = $('[data-hvs-add]', form), label = $('[data-hvs-label]', form); if (!btn || !label) { return; }
    clearTimeout(btn._t);
    label.textContent = text;
    btn.classList.add('is-said');
    btn._t = setTimeout(function () { label.textContent = 'Add'; btn.classList.remove('is-said'); }, ms);
  }

  /* ---- what is in the cart already ---- */
  function headerEls() { return $$('.header__cart-count, [data-cart-count]'); }
  function headerCount() {
    var el = $('.header__cart-count'), n = el ? parseInt(el.textContent, 10) : NaN;
    if (isNaN(n) && window.theme && typeof window.theme.cartCount === 'number') { n = window.theme.cartCount; }
    return isNaN(n) ? 0 : n;
  }
  function loadCart() {
    var g = gen;
    cartRead = true;
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        /* A tap since this request began makes its answer stale; the read after that tap settles it. */
        if (!c || !c.items || g !== gen || busy || hasPending()) { return; }
        var next = {};
        c.items.forEach(function (it) { next[it.variant_id] = (next[it.variant_id] || 0) + it.quantity; });
        qty = next;
        headerEls().forEach(function (el) { el.textContent = String(c.item_count); });
        paintAll();
      }).catch(function () {});
  }

  /* ---- the header's count and the flying packet ---- */
  function bumpHeader(delta) {
    headerEls().forEach(function (el) {
      var n = parseInt(el.textContent, 10); if (isNaN(n)) { n = 0; }
      el.textContent = String(Math.max(0, n + delta));
      if (delta > 0) { el.classList.remove('header__cart-count--bounce'); void el.offsetWidth; el.classList.add('header__cart-count--bounce'); setTimeout(function () { el.classList.remove('header__cart-count--bounce'); }, 500); }
    });
  }
  function cartIcon() {
    var found = null;
    $$('.header__cart-toggle, a[href="/cart"]').some(function (a) {
      var r = a.getBoundingClientRect();
      if (r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight && r.right > 0 && r.left < window.innerWidth) { found = a; return true; }
      return false;
    });
    return found;
  }
  function fly(btn) {
    if (reduce || !btn.animate) { return; }
    var cart = cartIcon(); if (!cart) { return; }
    var from = btn.getBoundingClientRect(), to = (cart.querySelector('.header__cart-icon, svg') || cart).getBoundingClientRect();
    var x0 = from.left + from.width / 2 - 8, y0 = from.top + from.height / 2 - 10, x1 = to.left + to.width / 2 - 8, y1 = to.top + to.height / 2 - 10;
    var packet = document.createElement('span'); packet.className = 'hvs-qs-fly'; packet.setAttribute('aria-hidden', 'true');
    document.body.appendChild(packet);
    var peak = Math.max(6, Math.min(y0, y1) - Math.min(120, Math.abs(x1 - x0) * 0.25 + 40));
    var move = packet.animate([
      { transform: 'translate(' + x0 + 'px,' + y0 + 'px) scale(1) rotate(0deg)', opacity: 1 },
      { transform: 'translate(' + (x0 + (x1 - x0) * 0.45) + 'px,' + peak + 'px) scale(.85) rotate(-12deg)', opacity: 1, offset: 0.45 },
      { transform: 'translate(' + x1 + 'px,' + y1 + 'px) scale(.35) rotate(0deg)', opacity: 0.4 }
    ], { duration: 560, easing: 'cubic-bezier(.33,.9,.5,1)', fill: 'forwards' });
    move.onfinish = function () { if (packet.parentNode) { packet.parentNode.removeChild(packet); } };
  }

  /* ---- Add ---- */
  function post(items) {
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin', keepalive: true,
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (j) {
        if (!res.ok) { var err = new Error((j && (j.description || j.message)) || 'Cart error'); err.status = res.status; throw err; }
        return j;
      });
    });
  }
  function refused(item, err) {
    var id = String(item.id), short = err && err.status === 422;
    qty[id] = Math.max(0, (qty[id] || 0) - item.quantity);
    bumpHeader(-item.quantity);
    paintId(id);
    $$('[data-hvs-qs]').forEach(function (f) { var el = chosen(f); if (el && el.value === id) { say(f, short ? 'Too many' : 'Try again', 2600); } });
    announce(short && err.message !== 'Cart error' ? err.message : (short ? 'Not enough of that size in stock.' : 'That did not reach your cart. Try again.'));
  }
  function send(items) {
    return post(items).catch(function (err) {
      /* A refused request adds nothing, so when several went together each goes again alone and only the short one fails. */
      if (err.status === 422 && items.length > 1) {
        return items.reduce(function (p, it) { return p.then(function () { return send([it]); }); }, Promise.resolve());
      }
      items.forEach(function (it) { refused(it, err); });
    });
  }
  function flush() {
    timer = null;
    if (busy) { return; }
    var ids = Object.keys(pending);
    if (!ids.length) { settled(); return; }
    var items = ids.map(function (id) { return { id: parseInt(id, 10), quantity: pending[id] }; });
    pending = {};
    busy = true;
    send(items).then(function () { busy = false; flush(); });
  }
  function settled() {
    selfRefresh = true;
    try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } })); } catch (e) {}
    selfRefresh = false;
    loadCart();
  }
  /* Which section the card is in, so You may also like and Recently viewed can be read apart from the grid. */
  function listOf(form) { var s = form.closest('[data-section-type]'); return s ? s.getAttribute('data-section-type') : ''; }
  function amount(input) {
    var n = input ? parseInt(input.value, 10) : 1;
    return n > 0 ? Math.min(n, 999) : 1;
  }
  function addTap(form, btn) {
    var el = chosen(form); if (!el || btn.disabled) { return; }
    var id = el.value, input = $('[data-hvs-qty]', form), n = amount(input), what = whatOf(form, el);
    qty[id] = (qty[id] || 0) + n;
    pending[id] = (pending[id] || 0) + n;
    gen++;
    fly(btn);
    bumpHeader(n);
    paintId(id);
    say(form, 'Added', 1300);
    if (input) { input.value = '1'; input.blur(); syncQty(form); }
    announce('Added ' + n + ' of ' + what + ' to your cart. ' + qty[id] + ' in your cart.');
    track('quick_shop_add', { item: what, variant: id, quantity: n, product: form.getAttribute('data-hvs-qs-handle') || '', page: (window.theme && window.theme.pageType) || '', list: listOf(form) });
    if (!busy) { clearTimeout(timer); timer = setTimeout(flush, 150); }
  }

  /* ---- the badge guide ---- */
  function keyOf(text) {
    var t = String(text || '').trim().toLowerCase();
    if (t.indexOf('not to') === 0) { return 'not'; }
    return t;
  }
  function openKey(which, from) {
    var d = $('#hvs-badge-key'); if (!d || !d.showModal) { return; }
    $$('[data-hvs-key-row]', d).forEach(function (r) { r.classList.toggle('is-on', r.getAttribute('data-hvs-key-row') === which); });
    if (!d.open) { d.showModal(); document.documentElement.classList.add('hvs-key-lock'); }
    var row = which && $('[data-hvs-key-row="' + which + '"]', d);
    if (row && row.scrollIntoView) { row.scrollIntoView({ block: 'nearest' }); }
    track('badge_key_open', { badge: which || '', from: from });
  }

  /* ---- Shop or Learn ---- */
  var KEY = 'hvs-zone', ZN = { tropical: 'Tropical', subtropical: 'Subtropical', arid: 'Arid and semi-arid', temperate: 'Temperate', mediterranean: 'Mediterranean', cool: 'Cool and alpine' };
  function zone() { try { var z = localStorage.getItem(KEY); return z && ZN[z] ? z : ''; } catch (e) { return ''; } }
  function applyZone(z, save) {
    var box = $('[data-hvs-learn]'); if (!box) { return; }
    var shown = z || 'temperate';
    $$('[data-hvs-zone-row]', box).forEach(function (r) { r.hidden = r.getAttribute('data-hvs-zone-row') !== shown; });
    $$('[data-hvs-zone-tab]', box).forEach(function (t) { t.setAttribute('aria-pressed', String(t.getAttribute('data-hvs-zone-tab') === shown)); });
    $$('[data-hvs-zone-name]', box).forEach(function (n) { n.textContent = ZN[shown]; });
    $$('[data-hvs-zone-change-label]', box).forEach(function (b) { b.textContent = z ? 'Change' : 'Choose your zone'; });
    document.documentElement.setAttribute('data-hvs-zone', z || '');
    if (save) { try { localStorage.setItem(KEY, z); } catch (e) {} track('zone_set', { zone: z, method: 'chip', page: 'collection' }); document.dispatchEvent(new CustomEvent('hvs:zone', { detail: { zone: z } })); }
  }
  function learnTab(btn) {
    var box = btn.closest('[data-hvs-learn]'), which = btn.getAttribute('data-hvs-learn-tab'), panel = $('#hvs-learn-panel', box);
    var open = which === 'learn' && panel && panel.hidden;
    $$('[data-hvs-learn-tab]', box).forEach(function (t) {
      var on = t.getAttribute('data-hvs-learn-tab') === (open ? 'learn' : 'shop');
      t.classList.toggle('is-on', on); t.setAttribute('aria-pressed', String(on));
      if (t.getAttribute('data-hvs-learn-tab') === 'learn') { t.setAttribute('aria-expanded', String(open)); }
    });
    if (panel) { panel.hidden = !open; }
    if (open) {
      var title = $('#hvs-learn-title a', panel) || $('#hvs-learn-title', panel);
      if (title) { title.setAttribute('tabindex', '-1'); try { title.focus({ preventScroll: true }); } catch (e) { title.focus(); } }
      track('collection_learn_open', { collection: box.getAttribute('data-hvs-collection') || '' });
    } else if (which === 'shop') {
      var grid = $('.product-list');
      if (grid) { var r = grid.getBoundingClientRect(); if (r.top < 0 || r.top > window.innerHeight * 0.7) { grid.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); } }
    }
  }

  /* ---- events ---- */
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) { return; }
    var a, form;
    if ((a = t.closest('[data-hvs-add]')) && (form = a.closest('[data-hvs-qs]'))) { e.preventDefault(); addTap(form, a); return; }
    if ((a = t.closest('[data-hvs-qminus]')) && (form = a.closest('[data-hvs-qs]'))) { e.preventDefault(); if (!a.disabled) { stepQty(form, -1); } return; }
    if ((a = t.closest('[data-hvs-qplus]')) && (form = a.closest('[data-hvs-qs]'))) { e.preventDefault(); if (!a.disabled) { stepQty(form, 1); } return; }
    if (t.closest('[data-hvs-key-open]')) { openKey('', 'link'); return; }
    if ((a = t.closest('.hvs-card-meta .primeBadges'))) {
      var label = $('.badgetitle', a);
      if (label) { e.preventDefault(); openKey(keyOf(label.textContent), 'badge'); }
      return;
    }
    if (t.closest('[data-hvs-key-close]')) { var kd = $('#hvs-badge-key'); if (kd && kd.open) { kd.close(); } return; }
    if (t.matches && t.matches('#hvs-badge-key')) { t.close(); return; }
    if ((a = t.closest('[data-hvs-learn-tab]'))) { learnTab(a); return; }
    if ((a = t.closest('[data-hvs-zone-more]'))) {
      var zs = $('#hvs-learn-zones'); if (!zs) { return; }
      var openZ = zs.hidden; zs.hidden = !openZ; a.setAttribute('aria-expanded', String(openZ));
      if (openZ) { var pressed = $('[data-hvs-zone-tab][aria-pressed="true"]', zs) || $('[data-hvs-zone-tab]', zs); if (pressed) { try { pressed.focus({ preventScroll: true }); } catch (err) {} } }
      return;
    }
    if ((a = t.closest('[data-hvs-zone-tab]'))) {
      applyZone(a.getAttribute('data-hvs-zone-tab'), true);
      var zbox = $('#hvs-learn-zones'), zm = $('[data-hvs-zone-more]');
      if (zbox) { zbox.hidden = true; } if (zm) { zm.setAttribute('aria-expanded', 'false'); try { zm.focus({ preventScroll: true }); } catch (err) {} }
      return;
    }
    if ((a = t.closest('[data-hvs-learn-guide]'))) { track('collection_learn_guide', { collection: (a.closest('[data-hvs-learn]') || document.body).getAttribute('data-hvs-collection') || '' }); return; }
    if ((a = t.closest('[data-hvs-learn-link]'))) { track('collection_learn_search', { collection: (a.closest('[data-hvs-learn]') || document.body).getAttribute('data-hvs-collection') || '' }); return; }
  });
  document.addEventListener('close', function (e) { if (e.target && e.target.id === 'hvs-badge-key') { document.documentElement.classList.remove('hvs-key-lock'); } }, true);
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t || !t.matches) { return; }
    if (t.matches('[data-hvs-qty]')) { t.value = String(amount(t)); var qf = t.closest('[data-hvs-qs]'); if (qf) { syncQty(qf); } return; }
    if (!t.matches('[data-hvs-select]')) { return; }
    var form = t.closest('[data-hvs-qs]'); if (!form) { return; }
    paint(form);
    /* On touch the select keeps focus after the phone's list closes, which would draw a focus ring nobody asked for. */
    if (coarse()) { t.blur(); }
    track('quick_shop_size', { product: form.getAttribute('data-hvs-qs-handle') || '', variant: t.value, list: listOf(form) });
  });
  document.addEventListener('input', function (e) { var t = e.target; if (t && t.matches && t.matches('[data-hvs-qty]')) { var f = t.closest('[data-hvs-qs]'); if (f) { syncQty(f); } } });
  document.addEventListener('focusin', function (e) { var t = e.target; if (t && t.matches && t.matches('[data-hvs-qty]')) { try { t.select(); } catch (err) {} } });
  document.addEventListener('focusout', function (e) { var t = e.target; if (t && t.matches && t.matches('[data-hvs-qty]') && !(parseInt(t.value, 10) > 0)) { t.value = '1'; } });
  document.addEventListener('keydown', function (e) {
    var t = e.target;
    /* A phone's Done key closes the keyboard; it does not buy. With a real keyboard, Enter is Add. */
    if (e.key === 'Enter' && t && t.matches && t.matches('[data-hvs-qty]') && coarse()) { e.preventDefault(); t.blur(); }
  });
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.matches || !f.matches('[data-hvs-qs]')) { return; }
    e.preventDefault();
    var b = $('[data-hvs-add]', f);
    if (b) { addTap(f, b); }
  });
  /* Leaving straight after a tap: send it now. */
  window.addEventListener('pagehide', function () { if (timer) { clearTimeout(timer); flush(); } });
  /* Back from another page: the picker and the counts are read again. Another script's cart change arrives the same way. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) { paintAll(); if ($('[data-hvs-qs]')) { loadCart(); } } });
  document.documentElement.addEventListener('cart:refresh', function () { if (!selfRefresh && !busy && !hasPending() && $('[data-hvs-qs]')) { setTimeout(loadCart, 800); } });

  function init() {
    paintAll();
    if ($('[data-hvs-qs]') && headerCount() > 0) { loadCart(); }
    if ($('[data-hvs-learn]')) { applyZone(zone(), false); }
    /* The theme swaps the grid in place on sort, filter and layout, and fetches You may also like and Recently viewed: the new
       cards need painting, inside the same task so a size is never seen empty. Cards that come after this script's first look at
       the cart read it then, once. */
    $$('[class*="__dynamic-part"], .product-recommendations, .recently-viewed-products-placeholder').forEach(function (box) {
      if (window.MutationObserver) {
        new MutationObserver(function () {
          paintAll();
          if (!cartRead && $('[data-hvs-qs]') && headerCount() > 0) { loadCart(); }
        }).observe(box, { childList: true });
      }
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }

  window.HVSQuickShop = { loadCart: loadCart, applyZone: applyZone, announce: announce, paintAll: paintAll, openKey: openKey };
})();
